export class AccessSessionExpiredError extends Error {
  constructor() {
    super('Your PPM session has expired. Sign in again to load Google Calendar.');
    this.name = 'AccessSessionExpiredError';
  }
}

export async function calendarApiFetch(
  input: RequestInfo | URL,
  init: RequestInit = {},
): Promise<Response> {
  const headers = new Headers(init.headers);
  headers.set('X-Requested-With', 'XMLHttpRequest');

  const response = await fetch(input, {
    ...init,
    credentials: 'include',
    headers,
  });

  if (response.status === 401) throw new AccessSessionExpiredError();
  return response;
}
